import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { PreVisitQuestion } from '@/api/preVisit/preVisitApi.types';
import { Button } from '@/components/ui/button';
import { Icon } from '@/components/common/Icon';
import { resolveLocalizedText } from '@/utils/localizedText';

interface RemovedPreVisitQuestionsListProps {
  questions: PreVisitQuestion[];
  onRestore: (question: PreVisitQuestion) => void;
}

export function RemovedPreVisitQuestionsList({
  questions,
  onRestore,
}: RemovedPreVisitQuestionsListProps) {
  const { t, i18n } = useTranslation('consultations');
  const [isExpanded, setIsExpanded] = useState(false);

  if (questions.length === 0) {
    return null;
  }

  return (
    <div className="border-t border-zooborder pt-3">
      <button
        type="button"
        onClick={function toggle() {
          setIsExpanded(function invert(previous) {
            return previous === false;
          });
        }}
        className="flex items-center gap-1.5 text-xs font-bold text-zoomuted"
      >
        <Icon name={isExpanded ? 'ChevronDown' : 'ChevronRight'} />
        {t('preVisitEditor.removedTitle', { count: questions.length })}
      </button>

      {isExpanded ? (
        <div className="space-y-2 mt-3">
          {questions.map(function renderQuestion(question) {
            return (
              <div
                key={question.code}
                className="flex items-center justify-between gap-3 p-2.5 border border-dashed border-zooborder rounded-xl"
              >
                <p className="text-sm text-zoomuted truncate">
                  {resolveLocalizedText(question.labelEn, question.labelPl, i18n.language)}
                </p>
                <Button
                  type="button"
                  variant="outline"
                  size="chip"
                  onClick={function restore() {
                    onRestore(question);
                  }}
                >
                  <Icon name="Undo" />
                  {t('preVisitEditor.restore')}
                </Button>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
